import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { DropdownField, useControlledField } from '@frontend/design-system';

interface Props {
  selectedId: string;
  onSelect: (id: string) => void;
  options: { id: string; name: string }[];
}

export const LocationSelectionStep = ({ options, selectedId, onSelect }: Props) => {
  const { t } = useTranslation('schedule-onboarding');

  const locationField = useControlledField({
    type: 'dropdown',
    required: true,
    onChange: onSelect,
    value: selectedId,
  });

  return (
    <DropdownField
      {...locationField}
      label={t('Select a Location')}
      name='location'
      startAdornment={<Icon name='location-small' css={{ marginRight: theme.spacing(1) }} />}
      css={{ maxWidth: 430 }}
    >
      {options.map(({ id, name }) => (
        <DropdownField.Option key={id} value={id}>
          {name}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};
